import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SuperAdmin = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [tenants, setTenants] = useState([]);
  const [stats, setStats] = useState(null);
  const [lockedTenants, setLockedTenants] = useState([]);
  const [pendingClients, setPendingClients] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '', domain: '', subdomain: '', owner_name: '',
    owner_email: '', owner_phone: '', plan: 'basic', expires_at: ''
  });
  const [newTenantInfo, setNewTenantInfo] = useState(null);
  const [showResetModal, setShowResetModal] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [resetForm, setResetForm] = useState({ username: '', password: '' });
  const [resetResult, setResetResult] = useState(null);
  const [showEditPlan, setShowEditPlan] = useState(false);
  const [editPlanForm, setEditPlanForm] = useState({ plan: "basic", expires_at: "" });

  const emptyForm = {
    name: '', domain: '', subdomain: '', owner_name: '',
    owner_email: '', owner_phone: '', plan: 'basic', expires_at: ''
  };

  useEffect(() => {
    const token = localStorage.getItem('super_admin_token');
    if (token) {
      setIsLoggedIn(true);
      fetchAll();
    }
  }, []);

  const updateTenantPlan = async () => {
    try {
      await axios.put(`https://app.hayahost.net/api/super-admin/tenants/${selectedTenant.id}`, {
        ...selectedTenant,
        plan: editPlanForm.plan,
        expires_at: editPlanForm.expires_at || null
      }, { headers: { Authorization: `Bearer ${getToken()}` } });
      alert("تم تحديث الخطة!");
      setShowEditPlan(false);
      fetchTenants();
    } catch (err) { alert("خطأ في التحديث"); }
  };

  const getToken = () => localStorage.getItem('super_admin_token');

  const fetchAll = () => {
    fetchStats();
    fetchTenants();
    fetchLockedTenants();
    fetchPendingClients();
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post('https://app.hayahost.net/api/super-admin/login', loginForm);
      localStorage.setItem('super_admin_token', res.data.token);
      setIsLoggedIn(true);
      fetchAll();
    } catch (err) {
      alert('بيانات غير صحيحة!');
    }
    setLoading(false);
  };

  const fetchStats = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/super-admin/stats', {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setStats(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchTenants = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/super-admin/tenants', {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setTenants(res.data.tenants);
    } catch (err) { console.error(err); }
  };

  const fetchLockedTenants = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/super-admin/locked', {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setLockedTenants(res.data.locked_tenants || []);
    } catch (err) { console.error(err); }
  };

  const fetchPendingClients = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/super-admin/pending-clients', {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setPendingClients(res.data.pending_clients || []);
    } catch (err) { console.error(err); }
  };

  const handleCreateTenant = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post('https://app.hayahost.net/api/super-admin/tenants', form, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setNewTenantInfo(res.data);
      setForm(emptyForm);
      fetchAll();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في إنشاء المكتب');
      fetchAll();
    }
    setLoading(false);
  };

  const handleToggleStatus = async (tenant) => {
    try {
      const res = await axios.put(
        `https://app.hayahost.net/api/super-admin/tenants/${tenant.id}/toggle`, {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      alert(res.data.message);
      fetchTenants();
    } catch (err) { console.error(err); }
  };

  const handleUnlock = async (id) => {
    try {
      const res = await axios.put(
        `https://app.hayahost.net/api/super-admin/tenants/${id}/unlock`, {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      alert(res.data.message);
      fetchAll();
    } catch (err) { alert('خطأ في رفع الحظر'); }
  };

  const handleApproveClient = async (id) => {
    try {
      const res = await axios.put(
        `https://app.hayahost.net/api/super-admin/clients/${id}/approve`, {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      alert(res.data.message);
      fetchAll();
    } catch (err) { alert('خطأ في الموافقة'); }
  };

  const handleRejectClient = async (id) => {
    if (!window.confirm('هل تريد رفض هذا الفرع؟')) return;
    try {
      const res = await axios.put(
        `https://app.hayahost.net/api/super-admin/clients/${id}/reject`, {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      alert(res.data.message);
      fetchAll();
    } catch (err) { alert('خطأ في الرفض'); }
  };

  const openResetModal = (tenant) => {
    setSelectedTenant(tenant);
    setResetForm({ username: '', password: '' });
    setResetResult(null);
    setShowResetModal(true);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.put(
        `https://app.hayahost.net/api/super-admin/tenants/${selectedTenant.id}/reset-password`,
        resetForm,
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setResetResult(res.data);
      fetchTenants();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في تغيير البيانات');
    }
    setLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('super_admin_token');
    setIsLoggedIn(false);
  };

  const getPlanLabel = (plan) => {
    const plans = {
      basic: { label: 'أساسي', color: '#666' },
      premium: { label: 'مميز', color: '#1a237e' },
      enterprise: { label: 'مؤسسي', color: '#1b5e20' }
    };
    return plans[plan] || { label: plan, color: '#666' };
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('ar-IQ');
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  if (!isLoggedIn) {
    return (
      <div style={styles.loginContainer}>
        <div style={styles.loginCard}>
          <div style={styles.loginLogo}>
            <div style={styles.loginLogoIcon}>🏦</div>
            <h1 style={styles.loginTitle}>HAYA HOST</h1>
            <p style={styles.loginSubtitle}>لوحة تحكم Super Admin</p>
          </div>
          <form onSubmit={handleLogin}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>اسم المستخدم</label>
              <input style={styles.input} value={loginForm.username}
                onChange={e => setLoginForm({...loginForm, username: e.target.value})}
                placeholder="superadmin" required />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>كلمة المرور</label>
              <input style={styles.input} type="password" value={loginForm.password}
                onChange={e => setLoginForm({...loginForm, password: e.target.value})}
                placeholder="••••••••" required />
            </div>
            <button style={styles.loginBtn} type="submit" disabled={loading}>
              {loading ? 'جاري الدخول...' : '🔐 تسجيل الدخول'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>

     {/* نافذة تعديل الخطة */}
{showEditPlan && selectedTenant && (
  <div style={styles.modalOverlay}>
    <div style={styles.modal}>
      <h3 style={styles.modalTitle}>✏️ تعديل خطة: {selectedTenant.name}</h3>
      <div style={styles.inputGroup}>
        <label style={styles.label}>الخطة</label>
        <select style={styles.input} value={editPlanForm.plan} onChange={e => setEditPlanForm({...editPlanForm, plan: e.target.value})}>
          <option value="basic">أساسي</option>
          <option value="premium">مميز</option>
          <option value="enterprise">مؤسسي</option>
        </select>
      </div>
      <div style={styles.inputGroup}>
        <label style={styles.label}>تاريخ انتهاء الاشتراك</label>
        <input style={styles.input} type="date" value={editPlanForm.expires_at} onChange={e => setEditPlanForm({...editPlanForm, expires_at: e.target.value})} />
      </div>
      <div style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
        <button style={{...styles.btn, background: '#1b5e20'}} onClick={updateTenantPlan}>✅ حفظ</button>
        <button style={{...styles.btn, background: '#666'}} onClick={() => setShowEditPlan(false)}>إلغاء</button>
      </div>
    </div>
  </div>
)}
      {/* نافذة تغيير بيانات الدخول */}
      {showResetModal && selectedTenant && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>🔑 تعديل بيانات دخول: {selectedTenant.name}</h3>
            {resetResult ? (
              <div style={styles.successCard}>
                <h4 style={{color: '#2e7d32', marginBottom: '15px'}}>✅ تم التعديل بنجاح!</h4>
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>اسم المستخدم</span>
                  <span style={{...styles.infoValue, color: '#1a237e', fontWeight: 'bold', fontSize: '20px'}}>
                    {resetResult.username}
                  </span>
                </div>
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>كلمة المرور</span>
                  <span style={{...styles.infoValue, color: '#c62828', fontWeight: 'bold', fontSize: '20px'}}>
                    {resetResult.password}
                  </span>
                </div>
                <p style={{color: '#e65100', fontSize: '13px', marginTop: '10px', background: '#fff3e0', padding: '10px', borderRadius: '8px'}}>
                  ⚠️ أرسل هذه البيانات للعميل فوراً!
                </p>
                <button style={styles.closeBtn} onClick={() => { setShowResetModal(false); setResetResult(null); }}>
                  إغلاق
                </button>
              </div>
            ) : (
              <form onSubmit={handleResetPassword}>
                <p style={{color: '#666', fontSize: '13px', marginBottom: '15px', background: '#f8f9fa', padding: '10px', borderRadius: '8px'}}>
                  اتركه فارغاً للإبقاء على القيمة الحالية أو توليد كلمة مرور عشوائية
                </p>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>اسم المستخدم الجديد (اختياري)</label>
                  <input style={styles.input} value={resetForm.username}
                    onChange={e => setResetForm({...resetForm, username: e.target.value})}
                    placeholder="اتركه فارغاً للإبقاء على الحالي" />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>كلمة المرور الجديدة (اختياري)</label>
                  <input style={styles.input} value={resetForm.password}
                    onChange={e => setResetForm({...resetForm, password: e.target.value})}
                    placeholder="اتركه فارغاً لتوليد كلمة مرور عشوائية" />
                </div>
                <div style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                  <button style={styles.submitBtn} type="submit" disabled={loading}>
                    {loading ? 'جاري التعديل...' : '🔑 تأكيد التعديل'}
                  </button>
                  <button style={styles.cancelBtn} type="button"
                    onClick={() => { setShowResetModal(false); setResetResult(null); }}>
                    إلغاء
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      <div style={styles.navbar}>
        <h1 style={styles.navTitle}>🏦 HAYA HOST - Super Admin</h1>
        <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
          {lockedTenants.length > 0 && (
            <div style={styles.alertBadge} onClick={() => setActiveTab('locked')}>
              🔴 {lockedTenants.length} محظور
            </div>
          )}
          {pendingClients.length > 0 && (
            <div style={{...styles.alertBadge, background: '#e65100'}} onClick={() => setActiveTab('pending_clients')}>
              ⏳ {pendingClients.length} فرع بانتظار موافقة
            </div>
          )}
          <button style={styles.logoutBtn} onClick={handleLogout}>خروج</button>
        </div>
      </div>

      <div style={styles.content}>
        <div style={styles.tabs}>
          {[
            { key: 'dashboard', label: '🏠 لوحة التحكم' },
            { key: 'tenants', label: `🏢 المكاتب (${tenants.length})` },
            { key: 'locked', label: `🔴 المحظورون (${lockedTenants.length})` },
            { key: 'pending_clients', label: `⏳ فروع بانتظار موافقة (${pendingClients.length})` },
            { key: 'create', label: '➕ مكتب جديد' },
          ].map(tab => (
            <button key={tab.key}
              style={{
                ...(activeTab === tab.key ? styles.tabActive : styles.tabBtn),
                ...(tab.key === 'locked' && lockedTenants.length > 0 ? { borderColor: '#c62828', color: activeTab === tab.key ? 'white' : '#c62828' } : {}),
                ...(tab.key === 'pending_clients' && pendingClients.length > 0 ? { borderColor: '#e65100', color: activeTab === tab.key ? 'white' : '#e65100' } : {})
              }}
              onClick={() => {
                setActiveTab(tab.key);
                if (tab.key === 'create') { setForm(emptyForm); setNewTenantInfo(null); }
              }}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* لوحة التحكم */}
        {activeTab === 'dashboard' && stats && (
          <>
            <div style={styles.statsGrid}>
              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}}>
                <div style={styles.statIcon}>🏢</div>
                <div style={styles.statNumber}>{stats.stats.total_tenants}</div>
                <div style={styles.statLabel}>إجمالي المكاتب</div>
              </div>
              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}}>
                <div style={styles.statIcon}>✅</div>
                <div style={styles.statNumber}>{stats.stats.active_tenants}</div>
                <div style={styles.statLabel}>مكاتب نشطة</div>
              </div>
              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #c62828, #e53935)'}}>
                <div style={styles.statIcon}>🔴</div>
                <div style={styles.statNumber}>{stats.stats.locked_tenants}</div>
                <div style={styles.statLabel}>مكاتب محظورة</div>
              </div>
              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #e65100, #f57c00)'}}>
                <div style={styles.statIcon}>⏳</div>
                <div style={styles.statNumber}>{stats.stats.pending_clients}</div>
                <div style={styles.statLabel}>فروع بانتظار موافقة</div>
              </div>
            </div>

            {/* تنبيه المحظورين */}
            {lockedTenants.length > 0 && (
              <div style={styles.lockedAlert}>
                <h3 style={{color: '#c62828', marginBottom: '10px'}}>⚠️ مكاتب محظورة تحتاج تدخلك!</h3>
                {lockedTenants.map((t, i) => (
                  <div key={i} style={styles.lockedAlertItem}>
                    <div>
                      <span style={{fontWeight: 'bold', color: '#c62828'}}>{t.name}</span>
                      <span style={{fontSize: '12px', color: '#666', marginRight: '10px'}}>
                        حُظر في: {formatDateTime(t.locked_at)}
                      </span>
                    </div>
                    <button style={styles.unlockBtn} onClick={() => handleUnlock(t.id)}>
                      🔓 رفع الحظر
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* تنبيه الفروع بانتظار موافقة */}
            {pendingClients.length > 0 && (
              <div style={{...styles.lockedAlert, background: '#fff3e0', borderColor: '#e65100'}}>
                <h3 style={{color: '#e65100', marginBottom: '10px'}}>⏳ فروع بانتظار موافقتك!</h3>
                {pendingClients.map((c, i) => (
                  <div key={i} style={{...styles.lockedAlertItem, borderColor: '#ffe0b2'}}>
                    <div>
                      <span style={{fontWeight: 'bold', color: '#e65100'}}>{c.customer_name}</span>
                      <span style={{fontSize: '12px', color: '#666', marginRight: '10px'}}>
                        من مكتب: {c.tenant_name}
                      </span>
                      <span style={{fontSize: '12px', color: '#666'}}>
                        {formatDateTime(c.created_at)}
                      </span>
                    </div>
                    <div style={{display: 'flex', gap: '5px'}}>
                      <button style={styles.unlockBtn} onClick={() => handleApproveClient(c.id)}>
                        ✅ موافقة
                      </button>
                      <button style={{...styles.unlockBtn, background: '#c62828'}} onClick={() => handleRejectClient(c.id)}>
                        ❌ رفض
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div style={styles.section}>
              <h2 style={styles.sectionTitle}>🕐 آخر المكاتب المضافة</h2>
              <div style={styles.tableCard}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHead}>
                      <th style={styles.th}>اسم المكتب</th>
                      <th style={styles.th}>الدومين</th>
                      <th style={styles.th}>المالك</th>
                      <th style={styles.th}>الخطة</th>
                      <th style={styles.th}>الحالة</th>
                      <th style={styles.th}>تاريخ الإنشاء</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.recent_tenants.map((t, i) => (
                      <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{t.name}</td>
                        <td style={styles.td}>{t.domain || '-'}</td>
                        <td style={styles.td}>{t.owner_name || '-'}</td>
                        <td style={styles.td}>
                          <span style={{color: getPlanLabel(t.plan).color, fontWeight: 'bold'}}>
                            {getPlanLabel(t.plan).label}
                          </span>
                        </td>
                        <td style={styles.td}>
                          <span style={{
                            background: t.is_locked ? '#ffebee' : t.status === 'active' ? '#e8f5e9' : '#ffebee',
                            color: t.is_locked ? '#c62828' : t.status === 'active' ? '#2e7d32' : '#c62828',
                            padding: '3px 10px', borderRadius: '10px', fontSize: '12px'
                          }}>
                            {t.is_locked ? '🔴 محظور' : t.status === 'active' ? '✅ نشط' : '❌ معطل'}
                          </span>
                        </td>
                        <td style={{...styles.td, fontSize: '12px'}}>{formatDate(t.created_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {/* الفروع بانتظار الموافقة */}
        {activeTab === 'pending_clients' && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>⏳ فروع بانتظار موافقتك</h2>
            {pendingClients.length === 0 ? (
              <div style={{background: 'white', borderRadius: '12px', padding: '40px', textAlign: 'center', color: '#2e7d32', fontSize: '18px'}}>
                ✅ لا توجد فروع بانتظار الموافقة
              </div>
            ) : (
              <div style={styles.tableCard}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHead}>
                      <th style={styles.th}>اسم الفرع</th>
                      <th style={styles.th}>اسم المستخدم</th>
                      <th style={styles.th}>المكتب</th>
                      <th style={styles.th}>النوع</th>
                      <th style={styles.th}>تاريخ الطلب</th>
                      <th style={styles.th}>إجراءات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingClients.map((c, i) => (
                      <tr key={c.id} style={{...(i % 2 === 0 ? styles.trEven : styles.trOdd), background: '#fff8e1'}}>
                        <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{c.customer_name}</td>
                        <td style={styles.td}>{c.username}</td>
                        <td style={{...styles.td, color: '#e65100'}}>{c.tenant_name}</td>
                        <td style={styles.td}>{c.customer_type === 'company' ? '🏢 شركة' : '👤 عادي'}</td>
                        <td style={{...styles.td, fontSize: '12px'}}>{formatDateTime(c.created_at)}</td>
                        <td style={styles.td}>
                          <div style={{display: 'flex', gap: '5px'}}>
                            <button style={{background: '#2e7d32', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold'}}
                              onClick={() => handleApproveClient(c.id)}>
                              ✅ موافقة
                            </button>
                            <button style={{background: '#c62828', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px'}}
                              onClick={() => handleRejectClient(c.id)}>
                              ❌ رفض
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* المحظورون */}
        {activeTab === 'locked' && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>🔴 المكاتب المحظورة</h2>
            {lockedTenants.length === 0 ? (
              <div style={{background: 'white', borderRadius: '12px', padding: '40px', textAlign: 'center', color: '#2e7d32', fontSize: '18px'}}>
                ✅ لا توجد مكاتب محظورة
              </div>
            ) : (
              <div style={styles.tableCard}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHead}>
                      <th style={styles.th}>اسم المكتب</th>
                      <th style={styles.th}>المالك</th>
                      <th style={styles.th}>الهاتف</th>
                      <th style={styles.th}>تاريخ الحظر</th>
                      <th style={styles.th}>إجراءات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lockedTenants.map((t, i) => (
                      <tr key={t.id} style={{...(i % 2 === 0 ? styles.trEven : styles.trOdd), background: '#fff5f5'}}>
                        <td style={{...styles.td, fontWeight: 'bold', color: '#c62828'}}>{t.name}</td>
                        <td style={styles.td}>{t.owner_name || '-'}</td>
                        <td style={styles.td}>{t.owner_phone || '-'}</td>
                        <td style={{...styles.td, fontSize: '12px'}}>{formatDateTime(t.locked_at)}</td>
                        <td style={styles.td}>
                          <div style={{display: 'flex', gap: '5px'}}>
                            <button style={styles.unlockBtn} onClick={() => handleUnlock(t.id)}>
                              🔓 رفع الحظر
                            </button>
                            <button style={{background: '#1a237e', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px'}}
                              onClick={() => openResetModal(t)}>
                              🔑 تغيير كلمة المرور
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* قائمة المكاتب */}
        {activeTab === 'tenants' && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>🏢 كل المكاتب</h2>
            <div style={styles.tableCard}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHead}>
                    <th style={styles.th}>#</th>
                    <th style={styles.th}>اسم المكتب</th>
                    <th style={styles.th}>الدومين</th>
                    <th style={styles.th}>المالك</th>
                    <th style={styles.th}>الهاتف</th>
                    <th style={styles.th}>الخطة</th>
                    <th style={styles.th}>العملاء</th>
                    <th style={styles.th}>الحوالات</th>
                    <th style={styles.th}>انتهاء الاشتراك</th>
                    <th style={styles.th}>الحالة</th>
                    <th style={styles.th}>إجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {tenants.map((t, i) => (
                    <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                      <td style={styles.td}>{t.id}</td>
                      <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{t.name}</td>
                      <td style={{...styles.td, fontSize: '12px'}}>{t.domain || (t.subdomain ? `${t.subdomain}.hayahost.com` : '-')}</td>
                      <td style={styles.td}>{t.owner_name || '-'}</td>
                      <td style={{...styles.td, fontSize: '12px'}}>{t.owner_phone || '-'}</td>
                      <td style={styles.td}>
                        <span style={{color: getPlanLabel(t.plan).color, fontWeight: 'bold'}}>
                          {getPlanLabel(t.plan).label}
                        </span>
                      </td>
                      <td style={{...styles.td, textAlign: 'center'}}>{t.customers_count || 0}</td>
                      <td style={{...styles.td, textAlign: 'center'}}>{t.transfers_count || 0}</td>
                      <td style={{...styles.td, fontSize: '12px', color: t.expires_at && new Date(t.expires_at) < new Date() ? '#c62828' : '#333'}}>
                        {formatDate(t.expires_at)}
                      </td>
                      <td style={styles.td}>
                        <span style={{
                          background: t.is_locked ? '#ffebee' : t.status === 'active' ? '#e8f5e9' : '#ffebee',
                          color: t.is_locked ? '#c62828' : t.status === 'active' ? '#2e7d32' : '#c62828',
                          padding: '3px 10px', borderRadius: '10px', fontSize: '12px'
                        }}>
                          {t.is_locked ? '🔴 محظور' : t.status === 'active' ? '✅ نشط' : '❌ معطل'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <div style={{display: 'flex', gap: '4px', flexDirection: 'column'}}>
                          {t.is_locked ? (
                            <button style={styles.unlockBtn} onClick={() => handleUnlock(t.id)}>
                              🔓 رفع الحظر
                            </button>
                          ) : (
                            <button style={{
                              background: t.status === 'active' ? '#c62828' : '#2e7d32',
                              color: 'white', border: 'none', padding: '4px 8px',
                              borderRadius: '6px', cursor: 'pointer', fontSize: '11px'
                            }} onClick={() => handleToggleStatus(t)}>
                              {t.status === 'active' ? '🔴 تعطيل' : '🟢 تفعيل'}
                            </button>
                          )}
                          <button style={{background: '#1a237e', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px'}}
                            onClick={() => openResetModal(t)}>
                            🔑 بيانات الدخول
                          </button>
                          <button style={{background: '#e65100', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px'}} onClick={() => { setSelectedTenant(t); setShowEditPlan(true); setEditPlanForm({ plan: t.plan || 'basic', expires_at: t.expires_at ? t.expires_at.split('T')[0] : '' }); }}>✏️ الخطة</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {tenants.length === 0 && <div style={styles.empty}>لا توجد مكاتب</div>}
            </div>
          </div>
        )}

        {/* إنشاء مكتب جديد */}
        {activeTab === 'create' && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>➕ إنشاء مكتب جديد</h2>

            {newTenantInfo && (
              <div style={styles.successCard}>
                <h3 style={{color: '#2e7d32', marginBottom: '15px'}}>🎉 تم إنشاء المكتب بنجاح!</h3>
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>اسم المكتب</span>
                  <span style={styles.infoValue}>{newTenantInfo.tenant?.name}</span>
                </div>
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>اسم المستخدم للدخول</span>
                  <span style={{...styles.infoValue, color: '#1a237e', fontWeight: 'bold', fontSize: '20px'}}>
                    {newTenantInfo.admin_username}
                  </span>
                </div>
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>كلمة المرور</span>
                  <span style={{...styles.infoValue, color: '#c62828', fontWeight: 'bold', fontSize: '20px'}}>
                    {newTenantInfo.admin_password}
                  </span>
                </div>
                <p style={{color: '#e65100', fontSize: '13px', marginTop: '10px', background: '#fff3e0', padding: '10px', borderRadius: '8px'}}>
                  ⚠️ احتفظ ببيانات الدخول وأرسلها للعميل فوراً - لن تظهر مرة أخرى!
                </p>
                <button style={styles.closeSuccessBtn} onClick={() => setNewTenantInfo(null)}>إغلاق</button>
              </div>
            )}

            <div style={styles.formCard}>
              <form onSubmit={handleCreateTenant}>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>اسم المكتب *</label>
                    <input style={styles.input} value={form.name}
                      onChange={e => setForm({...form, name: e.target.value})}
                      placeholder="مثال: مكتب البصرة للصرافة" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>الدومين المستقل</label>
                    <input style={styles.input} value={form.domain}
                      onChange={e => setForm({...form, domain: e.target.value})}
                      placeholder="مثال: albasra-exchange.com (اختياري)" />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Subdomain من HAYA HOST</label>
                    <input style={styles.input} value={form.subdomain}
                      onChange={e => setForm({...form, subdomain: e.target.value})}
                      placeholder="مثال: albasra (اختياري)" />
                    {form.subdomain && (
                      <span style={{fontSize: '12px', color: '#1a237e', marginTop: '4px', display: 'block'}}>
                        سيكون الرابط: {form.subdomain}.hayahost.com
                      </span>
                    )}
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>اسم المالك *</label>
                    <input style={styles.input} value={form.owner_name}
                      onChange={e => setForm({...form, owner_name: e.target.value})}
                      placeholder="اسم صاحب المكتب" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>البريد الإلكتروني</label>
                    <input style={styles.input} type="email" value={form.owner_email}
                      onChange={e => setForm({...form, owner_email: e.target.value})}
                      placeholder="email@example.com" />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>رقم الهاتف</label>
                    <input style={styles.input} value={form.owner_phone}
                      onChange={e => setForm({...form, owner_phone: e.target.value})}
                      placeholder="07XXXXXXXXX" />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>الخطة</label>
                    <select style={styles.input} value={form.plan}
                      onChange={e => setForm({...form, plan: e.target.value})}>
                      <option value="basic">أساسي</option>
                      <option value="premium">مميز</option>
                      <option value="enterprise">مؤسسي</option>
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>تاريخ انتهاء الاشتراك</label>
                    <input style={styles.input} type="date" value={form.expires_at}
                      onChange={e => setForm({...form, expires_at: e.target.value})} />
                  </div>
                </div>
                <button style={styles.submitBtn} type="submit" disabled={loading}>
                  {loading ? 'جاري الإنشاء...' : '➕ إنشاء المكتب'}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  loginContainer: { minHeight: '100vh', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  loginCard: { background: 'white', borderRadius: '20px', padding: '40px', width: '400px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  loginLogo: { textAlign: 'center', marginBottom: '30px' },
  loginLogoIcon: { fontSize: '48px', marginBottom: '10px' },
  loginTitle: { color: '#1a237e', fontSize: '24px', fontWeight: 'bold', margin: '0 0 5px' },
  loginSubtitle: { color: '#666', fontSize: '14px' },
  loginBtn: { width: '100%', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '14px', borderRadius: '10px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold', marginTop: '10px' },
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  alertBadge: { background: '#c62828', color: 'white', padding: '6px 14px', borderRadius: '20px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  content: { padding: '30px', maxWidth: '1400px', margin: '0 auto' },
  tabs: { display: 'flex', gap: '10px', marginBottom: '25px', flexWrap: 'wrap' },
  tabBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', color: '#666' },
  tabActive: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '25px' },
  statCard: { borderRadius: '15px', padding: '25px', color: 'white', textAlign: 'center' },
  statIcon: { fontSize: '32px', marginBottom: '10px' },
  statNumber: { fontSize: '32px', fontWeight: 'bold', marginBottom: '5px' },
  statLabel: { fontSize: '13px', opacity: 0.9 },
  lockedAlert: { background: '#ffebee', border: '2px solid #c62828', borderRadius: '12px', padding: '20px', marginBottom: '20px' },
  lockedAlertItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #ffcdd2' },
  unlockBtn: { background: '#2e7d32', color: 'white', border: 'none', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' },
  section: { marginBottom: '25px' },
  sectionTitle: { color: '#1a237e', fontSize: '20px', marginBottom: '15px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '25px' },
  inputGroup: { marginBottom: '5px' },
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl', boxSizing: 'border-box' },
  submitBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '14px 40px', borderRadius: '10px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'auto', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'right', fontSize: '12px', whiteSpace: 'nowrap' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '10px 15px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
  successCard: { background: '#e8f5e9', borderRadius: '12px', padding: '25px', marginBottom: '20px', border: '2px solid #2e7d32' },
  infoRow: { display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid rgba(0,0,0,0.1)' },
  infoLabel: { color: '#666', fontSize: '14px' },
  infoValue: { color: '#333', fontWeight: 'bold', fontSize: '14px' },
  closeSuccessBtn: { background: '#2e7d32', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', marginTop: '15px' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: '16px', padding: '30px', width: '500px', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' },
  modalTitle: { color: '#1a237e', marginBottom: '20px', fontSize: '18px', borderBottom: '2px solid #e3f2fd', paddingBottom: '10px' },
  cancelBtn: { background: '#f5f5f5', color: '#666', border: '1px solid #e0e0e0', padding: '12px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  closeBtn: { background: '#1a237e', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', marginTop: '15px' },
};

export default SuperAdmin;